import { Observation, ObservationComponent } from "@medplum/fhirtypes";

import { BirthingComponent, ShoulderDystociaComponent } from "@/fhir/enums/quilted-health";

export interface BirthMilestoneData {
  headDelivered?: string;
  bodyDelivered?: string;
  rom?: string;
}

export function extractBirthMilestonesFromROMObservation(
  observation?: Observation,
): BirthMilestoneData {
  if (!observation) {
    return {
      rom: undefined,
    };
  }

  return {
    rom: observation.valueDateTime,
  };
}

export function extractBirthMilestonesFromObservation(
  observation: Observation,
): BirthMilestoneData {
  if (!observation.component) {
    return {};
  }

  const milestones: BirthMilestoneData = {};

  observation.component.forEach((component: ObservationComponent) => {
    const code = component.code?.coding?.[0]?.code;
    const value = component.valueDateTime;

    switch (code) {
      case BirthingComponent.HeadDeliveredDateTime:
        if (value) {
          milestones.headDelivered = value;
        }
        break;
      case BirthingComponent.BodyDeliveredDateTime:
        if (value) {
          milestones.bodyDelivered = value;
        }
        break;
      // Shoulder dystocia form can also supply the birth (body delivered) time
      case ShoulderDystociaComponent.Birth:
        if (value) {
          milestones.bodyDelivered = value;
        }
        break;
    }
  });

  return milestones;
}

export function isBirthMilestoneObservation(observation: Observation): boolean {
  return (
    observation.code?.coding?.some(
      (coding) =>
        coding.code === "forms/laborFlowSheet/birthing" ||
        coding.code === "forms/laborFlowSheet/shoulderDystocia",
    ) ?? false
  );
}
